import React from 'react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="accueil" className="relative min-h-screen flex items-center pt-24">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1503708928676-1cb796a0891e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Chantier BTP AGIPLUS CI"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/95 via-green-800/90 to-orange-900/85"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-4xl">
          <div className="inline-block px-4 py-2 bg-orange-500/20 backdrop-blur-sm rounded-full border border-orange-400/30 mb-6">
            <span className="text-orange-300 font-semibold text-sm tracking-wide" data-testid="hero-badge">
              BTP • MÉCANIQUE • HYDRAULIQUE • LOCATION DE MATÉRIEL
            </span>
          </div>

          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-testid="hero-title">
            AGIPLUS <span className="text-orange-400">CI</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed max-w-3xl" data-testid="hero-subtitle">
            Nous accompagnons les entreprises dans leurs projets grâce à une offre intégrée
            de travaux, maintenance, réparation, hydraulique et mise à disposition d'équipements.
          </p>

          {/* Métiers badges */}
          <div className="flex flex-wrap gap-3 mb-10">
            {['BTP & Génie Civil', 'Mécanique & Hydraulique', 'Location de Matériel'].map((m) => (
              <span key={m} className="bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 border border-white/20 text-white font-medium text-sm">
                {m}
              </span>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button onClick={() => scrollTo('metiers')} size="lg" className="bg-green-600 hover:bg-green-700 text-white text-lg px-8 py-6" data-testid="hero-discover-btn">
              Découvrir nos métiers
            </Button>
            <Button onClick={() => scrollTo('contact')} size="lg" variant="outline" className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-white/30 text-lg px-8 py-6" data-testid="hero-contact-btn">
              Demander un devis
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
